document.addEventListener("DOMContentLoaded", function () {
  $("[data-fancybox='gallery']").fancybox({
    baseClass: "masonry-gallery-fancybox",
    thumbs: false,
    buttons: ["close"],
    clickSlide: false, // Prevent closing on slide click
    clickOutside: false,
    Toolbar: true,
      btnTpl: {
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="Previous">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="left-caret"><path d="M64.44,83.92a2,2,0,0,0-.47-.78L30.83,50,64,16.86a2,2,0,0,0,.47-.78l9.81-9.66a2,2,0,1,0-2.81-2.84l-45.69,45a2,2,0,0,0,0,2.84l45.69,45a2,2,0,1,0,2.81-2.84Z"/></g></svg>' +
        "</button>",

      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="Next">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="right-caret"><path d="M74.25,48.58l-45.69-45a2,2,0,1,0-2.81,2.84l9.81,9.66a2,2,0,0,0,.47.78L69.17,50,36,83.14a2,2,0,0,0-.47.78l-9.81,9.66a2,2,0,1,0,2.81,2.84l45.69-45a2,2,0,0,0,0-2.84Z"/></g></svg>' +
        "</button>",
    },
   afterShow: function (instance, current) {
      updatePagination(instance);

      
      // Add custom logo if not already present
      if (!$(".custom-logo-container").length) {
        let logoURL = window.customFancyboxLogo; // Get logo from Liquid
        if (logoURL) {
          $(".fancybox-infobar").after(
            '<div class="custom-logo-container">' +
              '<img src="' + logoURL + '">' +
            '</div>'
          );
        }
      }

      // Ensure the caption is added correctly
      setTimeout(() => addCustomCaption(current), 0);
    },
  });

  function addCustomCaption(slide) {
    if (!slide || !slide.$content) return;

    let img = slide.$content.find("img");
    if (img.length) {
      let captionText =
        slide.opts.$orig.data("caption") ||
        slide.opts.$orig.attr("title") ||
        img.attr("alt") ||
        "";

      if (captionText) {
        // Remove existing captions to prevent duplication
        slide.$content.find(".custom-fancybox-caption").remove();

        // Create and insert caption div
        let captionDiv = $('<div class="custom-fancybox-caption"></div>').html(captionText);
        img.after(captionDiv);
      }
    }
  }

  function updatePagination(instance) {
    let totalSlides = instance.group.length;
    let currentIndex = instance.currIndex + 1;

    // Remove existing dots
    $(".custom-fancybox-pagination").remove();

    // Create pagination container
    let paginationContainer = $('<div class="custom-fancybox-pagination"></div>');

    for (let i = 1; i <= totalSlides; i++) {
      let dot = $('<span class="fancybox-dot"></span>');

      // Add active class to current dot
      if (i === currentIndex) {
        dot.addClass("active");
      }

      // Click event to go to the selected slide
      dot.on("click", function () {
        instance.jumpTo(i - 1);
      });

      paginationContainer.append(dot);
    }

    // Append pagination to Fancybox
    $(".fancybox-inner").append(paginationContainer);
  }
});
